<div class="zentra-admin-success-dialog">
  <div mat-dialog-content class="message">
    <h2>Delete User?</h2>
    <p>
      Are you sure you want to delete <strong>{{ data.name }}</strong
      >?
    </p>
    <p class="sub-text">
      This action will revoke all Guest Purchaser permissions immediately.
    </p>
  </div>

  <div mat-dialog-actions class="actions">
    <!-- Cancel Button (Primary or Basic) -->
    <button color="primary" mat-stroked-button (click)="cancelDelete()">
      No - Go Back
    </button>

    <!-- Delete Button (Warn = Red) -->
    <button color="warn" mat-flat-button (click)="confirmDelete()">
      Yes - Delete
    </button>
  </div>
</div>
